(function () {
  'use strict';

  let resizeTimeout;
  let mutationTimeout;
  let isProcessing = false;

  function debounce(func, wait) {
    return function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(func, wait);
    };
  }

  function hideLastTagIfOverflow() {
    if (isProcessing) return;
    isProcessing = true;

    requestAnimationFrame(function () {
      try {
        const specRows = document.querySelectorAll(
          '.collection[data-collection-handle="operativni-leasing"] .card-list, .collection[data-collection-handle="operativni-leasing"] .spec-row',
        );

        if (specRows.length === 0) {
          isProcessing = false;
          return;
        }

        specRows.forEach(function (row) {
          const tags = row.querySelectorAll('.card-list__item, .spec-badge');

          if (tags.length <= 1) return;

          tags.forEach((tag) => {
            tag.style.display = 'flex';
            tag.style.visibility = 'visible';
          });

          const firstTagRect = tags[0].getBoundingClientRect();
          const lastTag = tags[tags.length - 1];
          const lastTagRect = lastTag.getBoundingClientRect();

          if (lastTagRect.top > firstTagRect.top + 5) {
            lastTag.style.display = 'none';
          }
        });
      } catch (e) {
        // Collection script error
      } finally {
        isProcessing = false;
      }
    });
  }

  function init() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(hideLastTagIfOverflow, { timeout: 1000 });
    } else {
      setTimeout(hideLastTagIfOverflow, 100);
    }

    const debouncedResize = debounce(hideLastTagIfOverflow, 150);
    window.addEventListener('resize', debouncedResize, { passive: true });

    const observer = new MutationObserver(function (mutations) {
      let hasChanges = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          hasChanges = true;
        }
      });

      if (hasChanges) {
        clearTimeout(mutationTimeout);
        mutationTimeout = setTimeout(hideLastTagIfOverflow, 150);
      }
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
